import * as React from "react";
import { Typography } from "@mui/material";

interface CustomButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: "primary" | "secondary" | "danger";
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  size?: "small" | "medium" | "large";
  type?: "button" | "submit" | "reset";
}

export default function CustomButton({
  children,
  onClick,
  variant = "primary",
  disabled = false,
  loading = false,
  fullWidth = false,
  size = "medium",
  type = "button",
}: CustomButtonProps) {
  const getStyles = () => {
    const baseStyles = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      padding: size === "small" ? "6px 16px" : size === "large" ? "10px 24px" : "8px 20px",
      borderRadius: "6px",
      cursor: disabled || loading ? "not-allowed" : "pointer",
      fontSize: size === "small" ? "0.875rem" : size === "large" ? "1rem" : "0.875rem",
      fontWeight: 500,
      transition: "all 0.2s",
      border: "none",
      outline: "none",
      width: fullWidth ? "100%" : "auto",
    };

    const variantStyles = {
      primary: {
        backgroundColor: "#212529",
        color: "#ffffff",
      },
      secondary: {
        backgroundColor: "#ffffff",
        color: "#212529",
        border: "1px solid #d1d5db",
      },
      danger: {
        backgroundColor: "#dc2626",
        color: "#ffffff",
      },
    };

    return { ...baseStyles, ...variantStyles[variant] };
  };

  return (
    <button
      type={type}
      onClick={!disabled && !loading ? onClick : undefined}
      disabled={disabled || loading}
      style={getStyles()}
    >
      {loading ? (
        <Typography variant="body2" sx={{ opacity: 0.7 }}>Loading...</Typography>
      ) : (
        <Typography variant="body2">{children}</Typography>
      )}
    </button>
  );
}
